<template>

    <div class="card-body">

        <div class="card">

            <div class="card-header">
                Perfis
            </div>

            <div class="card-body">
                <form>
                    <div class="form-group col-md-12">
                        <label>Perfil *</label>
                        <select class="form-control form-control-lg" @change="changeType" v-model="role_id">
                            <option value="">Selecione abaixo</option>
                            <option v-for="item in selectTypes" :value="item.id">{{ item.name }}</option>
                        </select>
                    </div>

                    <div class="form-group col-md-12" v-if="isPartner || isShopkeeper">
                        <label>Empresa *</label>
                        <select class="form-control form-control-lg select2" v-model="partner_id">
                            <option value="">Selecione abaixo</option>
                            <option v-for="item in selectPartners" :value="item.id">{{ item.name }}</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <span class="d-lg-flex"></span>
                        <span class="d-lg-flex"></span>
                    </div>

                    <div class="form-group col-md-12">

                        <button type="button" class="btn btn-sm btn-primary" @click="save">
                            <i class="fa fa-save mr-1"></i> Adicionar
                        </button>
                    </div>

                </form>

                <table class="table table-sm table-hover table-striped">
                    <thead>
                    <tr>
                        <th scope="col">Perfil</th>
                        <th scope="col">Informações</th>
                        <th scope="col">Ativo?</th>
                        <th scope="col" style="width: 100px;">

                        </th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="item in items" :id="'tr-' + item.id">
                        <td>{{ item.role }}</td>
                        <td>
                            <span v-if="item.partner">Parceiro: {{ item.partner }}</span>
                        </td>
                        <td>
                            <a href="javascript:" @click.prevent="updateStatus(item.id)" :id="'status-' + item.id">
                                <i class="fa fa-edit"></i> {{ item.active ? 'Sim' : 'Não' }}
                            </a>
                        </td>
                        <td>
                            <a data-toggle="tooltip" data-placement="bottom" title="Remover" href="javascript:"
                               class="btn btn-outline-info btn-default" @click.prevent="deleteItem(item.id)">
                                <i class="fa fa-trash-o"></i>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RoleUserListComponent",
        props: {
            roleList: {
                type: String,
                required: true
            },
            partnerList: {
                type: String,
                required: true
            },
            activeList: {
                type: String,
                required: true
            },
            baseUrl: {
                type: String,
                required: true
            },
            userId: {
                type: Number,
                required: true
            }
        },
        data() {

            return {
                role_id: null,
                partner_id: null,
                active: null,
                isShopkeeper: false,
                isPartner: false,
                isSponsor: false,
                items: []
            }
        },
        computed: {
            selectTypes() {
                return this.roleList ? JSON.parse(this.roleList) : {};
            },
            selectGroups() {
                return this.groupList ? JSON.parse(this.groupList) : {};
            },
            selectPlaces() {
                return this.placeList ? JSON.parse(this.placeList) : {};
            },
            selectPartners() {
                return this.partnerList ? JSON.parse(this.partnerList) : {};
            },
            selectActive() {
                return this.activeList ? JSON.parse(this.activeList) : {};
            },
        },
        methods: {
            changeType(event) {

                this.partner_id = null;
                this.isShopkeeper = false;
                this.isSponsor = false;
                this.isPartner = false;

                let value = parseInt(event.target.value);

                if (value === 2) {
                    //Cliente
                    this.isShopkeeper = true;

                } else if (value === 3) {
                    //Parceiro
                    this.isPartner = true;

                } else if (value === 1) {
                    //Administrador

                } else if (value === 4) {
                    //Frentista
                    this.isSponsor = true;

                }
            },
            getTypes() {

                axios.get(this.baseUrl + "/panel/role_users/ajax/" + this.userId)
                    .then((response) => {

                        this.items = [...response.data];
                    })
                    .catch(err => {
                        console.error(err);
                        showMessage('w', 'Erro ao recuperar informações');
                    });

            },
            save() {

                let url = this.baseUrl + "/panel/role_users/ajax/" + this.userId;
                let data = {
                    'role_id': this.role_id,
                    'place_id': this.place_id,
                    'user_id': this.userId,
                    'partner_id': this.partner_id,
                };

                //console.log(url, data);

                axios.post(url, data)
                    .then(function (response) {
                        showMessage('s', 'Salvo com sucesso');
                    })
                    .catch(function (error) {

                        let response = error.response.data;

                        if ($.isEmptyObject(response.errors)) {

                            showMessage('e', response.message);
                        } else {

                            for (let key in response.errors) {
                                if (response.errors.hasOwnProperty(key)) {
                                    let obj = response.errors[key];
                                    for (let prop in obj) {
                                        if (obj.hasOwnProperty(prop)) {
                                            showMessage('w', obj[prop]);
                                        }
                                    }
                                }
                            }
                        }
                    }).finally(() => {

                    this.role_id = null;
                    this.place_id = null;
                    this.partner_id = null;
                    this.getTypes();
                });
            },
            updateStatus(id) {

                let href = this.baseUrl + '/panel/role_users/ajax/active/' + id;
                axios.put(href)
                    .then((response) => {

                        let data = response.data.data;
                        $('#status-' + id).html('<i class="fa fa-edit"></i> ' + (data.active ? 'Sim' : 'Não'));
                    })
                    .catch(err => {
                        console.error(err);
                        showMessage('w', 'Erro ao atualizar!');
                    });
            },
            deleteItem(id) {

                if (confirm('Deseja remover esse perfil do usuário?')) {

                    let href = this.baseUrl + '/panel/role_users/ajax/delete/' + id;
                    axios.delete(href)
                        .then(() => {

                            $('#tr-' + id).remove();
                        })
                        .catch(err => {
                            console.error(err);
                            showMessage('w', 'Erro ao remover!');
                        });

                }
            }
        },
        mounted() {
            this.getTypes();
        }
    }
</script>

<style scoped>

</style>
